import { STEPS_BY_SECTION } from './constants';
import { SHOW_INFRASTRUCTURE_ALLOWED_ROLES } from '../common_components/authorization/allowed_roles';

export const sectionNameByValue = (value) => {
  for (const sectionName of Object.keys(STEPS_BY_SECTION)) {
    if (STEPS_BY_SECTION[sectionName].includes(value)) {
      return sectionName;
    }
  }
  return undefined;
};
